import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import theme from "./theme";

// styled-components v6 no longer auto-filters props on host elements (v5 did),
// so custom props (e.g. `active`, `toggle`, `isSelected`) would leak to the DOM
// as unknown-attribute React warnings. Restore v5 behaviour: forward only valid
// HTML attributes to DOM elements, and everything to wrapped React components.
const shouldForwardProp = (propName, target) =>
  typeof target === "string" ? isPropValid(propName) : true;

const CustomThemeProvider = ({ children }) => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyleSheetManager>
  );
};

export default CustomThemeProvider;
